exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3JGAwCe7tdh5h3{margin:0 auto;max-width:1250px}._28ABbGNOo14pa-{display:flex;flex-direction:column}._1YFIJWjZpn3szY{box-sizing:border-box;position:relative;will-change:max-height}._1YFIJWjZpn3szY+._1YFIJWjZpn3szY{padding-top:16px}._124XlYzVWl5iX7{margin-top:-24px}", ""]);

// exports
exports.locals = {
	"upNextCards": "_3JGAwCe7tdh5h3",
	"upNextCardList": "_28ABbGNOo14pa-",
	"upNextCardListItem": "_1YFIJWjZpn3szY",
	"homeNoUpNextCards": "_124XlYzVWl5iX7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2936/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/up-next-section.less
// module id = /ITi
// module chunks = 13